namespace $ {
	
	export const $mol_key_handle = Symbol.for( '$mol_key_handle' )
	export const $mol_key_store = new WeakMap< object, string >()
	
}
